/**
 * Extracts initials from a user's name
 * @param name The user's full name
 * @returns The user's initials (up to 2 characters)
 */
export function getUserInitials(name: string): string {
  if (!name || name.trim() === '') {
    return 'U'; // Default for unknown user
  }

  const nameParts = name.trim().split(' ');
  
  if (nameParts.length === 1) {
    // Single name - take first two characters
    return nameParts[0].substring(0, 2).toUpperCase();
  }
  
  // Multiple names - take first letter of first and last name
  const firstInitial = nameParts[0].charAt(0);
  const lastInitial = nameParts[nameParts.length - 1].charAt(0);
  
  return (firstInitial + lastInitial).toUpperCase();
}

/**
 * Formats a date string to DD MMM YY format as specified in requirements
 * @param dateString The date string to format
 * @returns Formatted date string
 */
export function formatDateShort(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  });
}

/**
 * Get badge color classes for categories
 * @param categoryName The category name
 * @returns Badge color classes
 */
export function getCategoryBadgeColor(categoryName: string): string {
  const categoryColors: { [key: string]: string } = {
    'Documentation': 'bg-blue-100 text-blue-800 border-blue-200',
    'Development': 'bg-green-100 text-green-800 border-green-200',
    'Testing': 'bg-purple-100 text-purple-800 border-purple-200',
    'Marketing': 'bg-pink-100 text-pink-800 border-pink-200',
    'Design': 'bg-orange-100 text-orange-800 border-orange-200',
    'Analysis': 'bg-indigo-100 text-indigo-800 border-indigo-200',
    'Content': 'bg-teal-100 text-teal-800 border-teal-200',
    'Support': 'bg-amber-100 text-amber-800 border-amber-200'
  };

  return categoryColors[categoryName] || 'bg-gray-100 text-gray-800 border-gray-200';
}